import { InternalTransactions } from '../types';
export const isCustomTransactionName = (name) => !Object.values(InternalTransactions).includes(name);
//# sourceMappingURL=transaction-utils.js.map